import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_LEAK_TEST_PACK,
  LINK_LEAK_TEST_PACK_JOBS,
  UPDATE_LEAK_TEST_PACK,
} from '../../../graph-queries/tar/leakTestPack';
import { TLeakTestPack } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import LeakTestPackForm from '../LeakTestPackForm/LeakTestPackForm';
import classes from './JobAspects.module.scss';
import { columns } from '../../pages/LeakTestPacks/LeakTestPacks';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobLeakTestPack: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_LEAK_TEST_PACK, {
    variables: { jobId },
  });
  const [updateLeakTestPack] = useMutation(UPDATE_LEAK_TEST_PACK, {
    refetchQueries: [GET_JOB_LEAK_TEST_PACK],
  });
  const [linkLeakTestPackJobs] = useMutation(LINK_LEAK_TEST_PACK_JOBS, {
    refetchQueries: [GET_JOB_LEAK_TEST_PACK],
  });

  const onEditSubmit = (leaktestpack: TLeakTestPack) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = leaktestpack;
    return updateLeakTestPack({ variables: { input } });
  };

  const onLinkSubmit = (selection: TLeakTestPack[], jobIds: number[]) => {
    return Promise.all(
      selection.map((leaktestpack) =>
        linkLeakTestPackJobs({
          variables: {
            leakTestPackId: leaktestpack.leakTestPackId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TLeakTestPack>
      aspectName="leaktestpack"
      data={(data?.leakTestPacksByJobId as unknown as TLeakTestPack[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <LeakTestPackForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Leak Test Packs</div>}
    />
  );
};

export default JobLeakTestPack;
